const getGroups = (groupBy, options) => groupBy ? Array.from(new Set(options.map((item) => groupBy(item)))) : [""];
const getOptionsByGroup = (groupBy, groups, options) => groups.map((group) => ({
  group,
  options: groupBy ? options.filter((item) => groupBy(item) === group) : options
}));

export { getGroups, getOptionsByGroup };
//# sourceMappingURL=utils.es.js.map
